import { TFunction } from '@mint-lib/i18n';

export enum NotificationTabs {
  accounts = 'accounts',
  average = 'averagekpis',
  dsp = 'dspcost',
  instruction = 'instruction',
  mediakit = 'mediakit',
  reviews = 'reviews',
  adserverCost = 'adservercost',
  emailSuggestions = 'emailsuggestions',
  overview = 'overview',
}

export type TabType = {
  id: NotificationTabs;
  label: string;
  disabled?: boolean;
};

export const tabs = (t: TFunction): { [integration: string]: TabType[] } => ({
  google_analytics: [
    {
      id: NotificationTabs.accounts,
      label: t('Accounts'),
    },
    {
      id: NotificationTabs.overview,
      label: t('Overview'),
      disabled: false,
    },
  ],
  adform_ad_server: [
    {
      id: NotificationTabs.accounts,
      label: t('Accounts'),
    },
    {
      id: NotificationTabs.overview,
      label: t('Overview'),
      disabled: false,
    },
  ],
  oneTwoWaysTabs: [
    {
      id: NotificationTabs.accounts,
      label: t('Accounts'),
    },
    {
      id: NotificationTabs.overview,
      label: t('Overview'),
      disabled: false,
    },
  ],
  virtualTabs: [
    {
      id: NotificationTabs.emailSuggestions,
      label: t('Email Suggestions'),
    },
    {
      id: NotificationTabs.overview,
      label: t('Overview'),
      disabled: false,
    },
  ],
  virtualBrandSafetyTabs: [
    {
      id: NotificationTabs.instruction,
      label: t('Instructions'),
    },
    {
      id: NotificationTabs.overview,
      label: t('Overview'),
      disabled: false,
    },
  ],
  default: [
    {
      id: NotificationTabs.overview,
      label: t('Overview'),
      disabled: false,
    },
  ],
});

export type TabsMap = ReturnType<typeof tabs>;
export type TabKey = keyof TabsMap;
